<template>
	<div>
		<div id="new-version-page" class="page centered-container">
			<NewVersion></NewVersion>
		</div>
	</div>
</template>

<script>
import NewVersion from '@/components/NewVersion.vue';
export default {
	name: 'NewVersionPage',
	components: {
		NewVersion
	},
	props: [],
	data: function () {
		return ar.state;
	}
};
</script>

<style lang="scss" scoped>
.page {
	position: absolute;
	height: 100%;
	width: 100%;
}
</style>
